import { getStyle } from "../../hooks/use-styles";
import ImageRowItem from "../ImageRowItem";
import "./style.css";

const HexIconContent = ({
  icon,
  title,
  value,
  onClick,
  className,
  titleClass,
  valueClass,
  imageSrc,
  loading,
  error,
}) => {
  return (
    <div
      className={`flex align-center justify-between ${className || ""}`}
      onClick={onClick}
    >
      <ImageRowItem
        title={title}
        titleClass={titleClass || "font-18-regular-500-lh-22"}
        subTitle={
          loading ? (
            "Loading Address..."
          ) : error ? (
            <div className="flex align-center">
              <div className="ellipse-text value-ellipse">{value}</div>
              <span
                className="ml-4"
                style={{ color: getStyle("tileRedColor") }}
              >
                {error}
              </span>
            </div>
          ) : (
            value
          )
        }
        subTitleClass={valueClass || "image-content-description"}
        imageSrc={icon}
      />

      {value && !error && (
        <div className="success-check-icon">
          <img
            src={imageSrc || "/assets/icons/success-check.svg"}
            alt="success"
          />
        </div>
      )}
    </div>
  );
};

export default HexIconContent;
